import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'
import { RoleId } from '@src/types/common/RoleId'

export const apiATPGetAspects = () => {

  const data = {

  }
  const axOptions = {
    method: 'GET',
    url: `${BASE_API_URL}/ref/atpaspect`,
    data,
    params: {
      
      reqRole: RoleId.ProjectManager,
      reqDev: 'web',
    }
  }
  return ax(axOptions)
}